import React from "react";
const d3 = require("d3");
const childComponents = {
  negativeGrowthChartComponent: require("./ChildComponents/negativeGrowthChartComponent.js"),
  targetAchievementChartComponent: require("./ChildComponents/targetAchievementChartComponent.js"),
  groupedBarChartComponent: require("./ChildComponents/groupedBarChartComponent.js"),
  axiomBarChartComponent: require("./ChildComponents/axiomBarChartComponent.js"),
  kpiValueComparedToRedOrangeTargetComponent: require("./ChildComponents/kpiValueComparedToRedOrangeTargetComponent.js"),
};

function getChildComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo,
  extraParams
) {
  if (!childComponents[componentName]) {
    return <div>Invalid Component {componentName}</div>;
  }
  const childComponent = childComponents[componentName](...arguments);
  return (
    <div>
      <div className="childComponentTitle">
        {childComponent.title.map((d, index) => {
          return (
            <span key={"span_" + index} className={d.class}>
              {d.text}
            </span>
          );
        })}
      </div>
      {childComponent.component}
    </div>
  );
}

module.exports = getChildComponent;
